import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import { useContext } from "react";
import LandLordContext from "../../context/landlord/LandLordContext";
import LoadingSpinner from "../LoadingSpinner";

const NotificationCustomization = ({
  workspaceMemberInfo,
  memberLoading,
  loadMembersData,
}) => {
  const { _t } = useTranslator();
  const { updateWorkspaceEmailPreference } = useContext(LandLordContext);
  const [toggleLoading, setToggleLoading] = useState(false);

  const handleUpdateUsersPreference = async () => {
    try {
      setToggleLoading(true);
      await updateWorkspaceEmailPreference({
        tenant_signup: !workspaceMemberInfo?.email_settings?.tenant_signup,
      });
      await loadMembersData();
    } catch (error) {
      console.error("Error updating email preference:", error);
    } finally {
      setToggleLoading(false);
    }
  };

  return (
    <>
      <Modal.Body className="invitation-tab manage-workspace-notification-tab">
        <h4 className="profile-picture-heading profile-picture-heading-notification">
          {_t("myEmailPreferencesInThisWorkspace")}
        </h4>
        <p className="p-3 m-0 rounded-4 manage-workspace-notification-tab-text">
          {_t(
            "inAppNotificationsAreAlwaysOnTheseSettingsOnlyAffectEmailSentToYouForThisWorkspace"
          )}
        </p>
        <div className="d-flex justify-content-between align-items-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <div>
              <div className="outer-label inner-span-style">
                <label>{_t("newTenantSignupEmailTogglerTitle")}</label>
              </div>
              <p className="company-name-text company-name-width w-100">
                {_t("newTenantSignupEmailTogglerDescription")}
              </p>
            </div>
          </div>
          <div className="d-flex align-items-center">
            {(toggleLoading || memberLoading) && (
              <LoadingSpinner
                size={"16px"}
                color="#7F7F7F"
                borderWidth={2}
                className="docs-loading-spinner"
              />
            )}
            <label className="custom-toggle-wrapper custom-toggle-wrapper-invitation">
              <input
                type="checkbox"
                disabled={toggleLoading || memberLoading}
                checked={
                  workspaceMemberInfo?.email_settings?.tenant_signup || false
                }
                onChange={handleUpdateUsersPreference}
              />
              <span className="custom-toggle-slider" />
            </label>
          </div>
        </div>
      </Modal.Body>
    </>
  );
};

export default NotificationCustomization;
